export const initialState = {
  shop_information_id: null,
  type: 'DELIVERY',
  product_name: '',
  product_content: '',
  product_category_id: null,
  is_show: 'Y',
  is_inventory: 'N',

  application_status: 'APPLY',
  product_status: 'WAIT',
  is_refund: 'Y',
  num: 0,
  price: 0,
  packaging_method: 'GENERAL',
  tax_type: 'TAXABLE',
  tax_rate: 0,
  is_store_pickup: 'N',
  is_bundle_delivery: 'N',
  is_restocking_notification: 'Y',
  product_detail: {},
  product_code: '',
  forwarding_location_id: null,
  forwarding_information: '',
  /* 25.02.04 추가데이터 */
  auto_confirm: 0, // 자동확정일
  receive_ids: {}, // 수령지
  regular_information: {}, // 정기배송 정보
  rental_information: {}, // 렌탈 정보
  is_present: 'N', // 선물여부
  //
  product_policy: {
    commission_rate: 0,
    discount_rate: 0,
    discount_type: 'W',
    is_enable: 'Y',
    is_show: 'Y',
    max_discount_price: 0,
    policy_status: 'POSSIBLE',
    policy_type: 'GENERAL',
    reserve_rate: 0,
    reserve_type: 'W',
    share_ratio: 100,
    present_information: {},
  }, //상품 정책(할인)
};

export const productReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_TYPE':
      return {
        ...state,
        type: action.value,
      };
    case 'CHANGE_PRODUCT_NAME':
      return {
        ...state,
        product_name: action.value,
      };
    case 'CHANGE_PRDUCT_STATUS':
      return {
        ...state,
        product_status: action.value,
      };
    case 'CHANGE_NUM':
      return {
        ...state,
        num: action.value,
      };
    case 'CHANGE_PACKAGING_METHOD':
      return {
        ...state,
        packaging_method: action.value,
      };
    case 'CHANGE_PRICE':
      return {
        ...state,
        price: action.value,
      };
    case 'CHANGE_TAX_TYPE':
      return {
        ...state,
        tax_type: action.value,
      };
    case 'CHANGE_TAX_RATE':
      return {
        ...state,
        tax_rate: action.value,
      };
    case 'CHANGE_PRODUCT_CATEGORY_ID':
      return {
        ...state,
        product_category_id: action.value,
      };
    case 'CHANGE_SHOP_INFORMATION_ID':
      return {
        ...state,
        shop_information_id: action.value,
      };
    case 'APPEND_PRODUCT_DETAIL':
      return {
        ...state,
        product_detail: {
          ...state.product_detail,
          [action.value]: '',
        },
      };
    case 'CHANGE_PRODUCT_DETAIL':
      return {
        ...state,
        product_detail: {
          ...state.product_detail,
          [action.value.detailKey]: action.value.detailValue,
        },
      };
    case 'CHANGE_PRODUCT_CODE':
      return {
        ...state,
        product_code: action.value,
      };
    case 'CHANGE_FORWADING_LOCATION_ID':
      return {
        ...state,
        forwarding_location_id: action.value,
      };
    case 'CHANGE_FORWADING_INFORMATION':
      return {
        ...state,
        forwarding_information: action.value,
      };
    case 'CHANGE_PRODUCT_CONTENT':
      return {
        ...state,
        product_content: action.value,
      };
    case 'CHANGE_IS_REFUND':
      return {
        ...state,
        is_refund: action.value,
      };
    case 'CHANGE_IS_RESTOCKING_NOTIFICATION':
      return {
        ...state,
        is_restocking_notification: action.value,
      };
    case 'CHANGE_IS_INVENTORY':
      return {
        ...state,
        is_inventory: action.value,
      };
    case 'CHANGE_IS_PRODUCT_POLICY':
      return {
        ...state,
        product_policy: {
          ...state.product_policy,
          ...action.value,
        },
      };

    /* === 추가항목 === */
    case 'auto_confirm':
      return {
        ...state,
        auto_confirm: action.value,
      };
    case 'receive_ids':
      return {
        ...state,
        receive_ids: action.value,
      };
    case 'regular_information':
      return {
        ...state,
        regular_information: action.value,
      };
    case 'rental_information':
      return {
        ...state,
        rental_information: {
          ...state.rental_information,
          ...action.value,
        },
      };
    case 'is_present':
      return {
        ...state,
        is_present: action.value,
      };

    case 'present_information':
      return {
        ...state,
        present_information: {
          ...state.present_information,
          ...action.value,
        },
      };
    default:
      throw new Error(`${action.type}을 찾을 수 없습니다.`);
  }
};
